import AgentLocalState from 'models/agent_local_state';
import clearExcessSnowplowStorage from 'scripts/adapters/stores/lib/clear_excess_snowplow_storage';
import ErrorReporter from 'scripts/infrastructure/error_reporter';
import getStorageSizes from 'scripts/adapters/stores/lib/get_storage_sizes';
import { AGENT_PREFERENCES_CACHE_KEY } from './lib/legacy_agent_preferences';

const AGENT_LOCAL_STATE_KEY = 'gladly-agent-local-state';

export default class AgentLocalStateStore {
  get() {
    // Migration: when nothing is written under the new key, fall back to the legacy
    // gladly-agent-preferences blob; AgentLocalState.fromJs filters to its own props.
    try {
      const raw = localStorage.getItem(AGENT_LOCAL_STATE_KEY) || localStorage.getItem(AGENT_PREFERENCES_CACHE_KEY);
      return AgentLocalState.fromJs((raw && JSON.parse(raw)) || {});
    } catch (e) {
      return new AgentLocalState();
    }
  }

  set(state) {
    const serialized = JSON.stringify(state.toJs());
    try {
      localStorage.setItem(AGENT_LOCAL_STATE_KEY, serialized);
    } catch (e) {
      const sizes = getStorageSizes(localStorage);
      clearExcessSnowplowStorage(localStorage);
      try {
        localStorage.setItem(AGENT_LOCAL_STATE_KEY, serialized);
        return;
      } catch (retryErr) {
        ErrorReporter.reportError(retryErr, {
          extra: {
            originalError: e,
            sizes,
            sizesAfterClearing: getStorageSizes(localStorage),
          },
        });
      }
    }
  }
}
